import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfirmationService } from 'primeng/api';

export const canActivateFeature: CanActivateFn = (next: ActivatedRouteSnapshot) => {
  const confirmationService = inject(ConfirmationService);

  const confirm = (): boolean => {
    confirmationService.confirm({
      message: 'This feature is not yet available.',
      header: 'Coming Soon!',
      closable: true,
      closeOnEscape: true,
      acceptLabel: 'OK',
      rejectVisible: false,
    });
    return false;
  };

  const features = environment.featureFlags;
  if (!Object.prototype.hasOwnProperty.call(next.data, 'feature')) {
    return true;
  }
  const feature = next.data['feature'];
  const isFeatureEnabled = features.some((f) => f.feature === feature && f.enabled);
  return isFeatureEnabled ? true : confirm();
};
